import { Button, Grid, Typography } from '@mui/material'
import { useState } from 'react'

import { Dialog } from '../dialog.tsx'
import { Icon } from '../icon.tsx'
import { User } from '../../types.ts'
import { EMPTY_VALUE } from '../../constants.ts'
import { useUser } from '@/stores/slices/user-slice.ts'

export const PROFILE_RENDERERS: Array<{
  key: keyof Omit<User, 'partner' | 'tspList'>
  label: string
  renderer?(user: User): string
}> = [
  {
    key: 'firstName',
    label: 'ФИО',
    renderer: (user) => [user.lastName, user.firstName, user.middleName].filter((value) => !!value).join(' '),
  },
  {
    key: 'id',
    label: 'Организация',
    renderer: (user) => user.partner.name ?? '',
  },
  {
    key: 'phone',
    label: 'Телефон',
  },
  {
    key: 'login',
    label: 'Email',
  },
]
export const ProfileButton = (): React.ReactElement | null => {
  const [showUserInfo, setShowUserInfo] = useState(false)
  const user = useUser()

  const toggleDialog = (visible: boolean) => () => setShowUserInfo(visible)
  if (!user) return null

  const userName = [user.firstName, `${user.lastName.charAt(0)}.`].join(' ')
  return (
    <>
      <Button startIcon={<Icon name="Profile" />} color="secondary" size="small" onClick={toggleDialog(true)}>
        {userName}
      </Button>
      <Dialog
        open={showUserInfo}
        onClose={toggleDialog(false)}
        title="Мои данные"
        content={
          <Grid container flexDirection="column">
            {PROFILE_RENDERERS.map(({ key, renderer, label }) => (
              <Grid
                item
                container
                xs={12}
                key={key}
                flexDirection="row"
                sx={{
                  py: 4,
                  '&:first-child': {
                    borderTop: '1px solid',
                    borderColor: 'lines.grey',
                  },
                  borderBottom: '1px solid',
                  borderColor: 'lines.grey',
                }}
              >
                <Grid item xs={12} md={4}>
                  <Typography color="text.secondary">{label}</Typography>
                </Grid>
                <Grid item xs={12} md={8}>
                  {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                  {/* @ts-expect-error */}
                  <Typography>{renderer ? renderer(user) : user[key] ?? EMPTY_VALUE}</Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
        }
      />
    </>
  )
}
